export default "__VITE_ASSET__CMZyiW_o__"